import { Company } from './company'

const USER_STATUS = {
  ENABLED: 'ENABLED',
  DISABLED: 'DISABLED',
  INVITED: 'INVITED',
  ARCHIVED: 'ARCHIVED'
}

type UserStatusOptions = typeof USER_STATUS[keyof typeof USER_STATUS]

type view_preference = 'list' | 'grid'

type Group = {
  name: string
  permissions: any
  company: Company
  created_by?: string
}

export enum UserRole {
  ADMIN = 'Admin',
  MANAGER = 'Manager',
  CONTRIBUTOR = 'Contributor',
  READONLY = 'Read Only'
}

export interface UserViewPreference {
  products: view_preference
  components: view_preference
  construction_details: view_preference
  point_of_measure: view_preference
  bill_of_materials: view_preference
  blocks: view_preference
}

export type User = {
  _id: string
  name: string
  first_name: string
  last_name: string
  firstName?: string
  lastName?: string
  title: string
  email: string
  phone: string
  avatar?: string
  locale: string
  status: UserStatusOptions
  company?: Company
  verification_code?: number
  setup_code?: number
  objects_sort_pref: string
  components_sort_pref: string
  details_sort_pref: string
  pom_sort_pref: string
  preset_sort_pref: string
  file_sort_pref: string
  item_master_sort_pref: string
  component_master_sort_pref: string
  bom_template_sort_pref: string
  utilization_report_library_sort_pref: string
  palette_library_sort_pref: string
  color_book_library_sort_pref: string
  size_spec_uom_pref: string
  phone_verified: boolean
  groups: Array<Group>
  role: UserRole
  created_by: string
  last_active: Date
  feature_tutorials: Array<string>
  view_preference: UserViewPreference
  hidden_pom_fields: Array<string>
  hidden_sample_fields: Array<string>
  size_spec_view: 'base' | 'combined' | 'graded' | 'gradeRules'
  api_key?: string
  password_reset_token: string
  token_expires: Date
  createdAt: Date
  updatedAt: Date
  homepage: string
  show_dense_item_view?: boolean
}

export interface UserPermissions {
  admin: boolean
}

export interface UserGroup {
  labelColor: string
  users: unknown[]
  _id: string
  name: string
  permissions: UserPermissions
  company: string
  createdAt: string
  updatedAt: string
}
